import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const GroupSearch = () => (
  <ImageIcon src={Images.GroupSearch} alt="group-search" />
);

export default GroupSearch;
